import * as lodash from "src/shared/libs/lodash";
//@ts-ignore
export const _ = lodash;
